import styled from 'styled-components';
import { Link } from 'react-router-dom';

const SidePanel = styled.div`
  background-color: var(--side-panel-color);
  border-${({ right }) =>
    right ? 'left' : 'right'}: 0.5px solid var(--border-color);
  height: 100%;
  ${({ width }) => width && `width: ${width};`}
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  h4 {
    font-weight: bold;
  }
  overflow: hidden;
  grid-area: 2 / 1;
  width: var(--side-panel-width);
`;

export default SidePanel;

export const PanelSection = styled.div`
  padding: var(--side-panel-padding);
  ${({ $hideBottomBorder }) =>
    $hideBottomBorder ? '' : 'border-bottom: 0.5px solid var(--border-color);'}
`;

export const PanelMainGroup = styled.div`
  overflow-y: scroll;
  flex-grow: 1;
  flex-shrink: 1;
  ul {
    margin-left: calc(-1 * var(--side-panel-padding));
    margin-right: calc(-1 * var(--side-panel-padding));
  }
`;

const stylePanelTab = (Tab) => styled(({ isActive, ...rest }) => (
  <Tab {...rest} />
))`
  font-weight: ${({ isActive }) => (isActive ? 'bold' : 'regular')};
  color: ${({ isActive }) =>
    isActive ? 'var(--text-color)' : 'var(--text-muted-color)'};
  margin-right: 1rem;
`;

export const PanelLink = stylePanelTab(Link);
export const PanelTab = stylePanelTab((props) => <div {...props} />);
